const BxfDataVizConstants = {
    CONTAINER: 'bxf-data-viz__container',
    ROTATION: 270,
    MARGIN: 20,
    LINE: 'line',
    AREA: 'area',
    SPLINE: 'spline',
    XGRIDLINE: 'highcharts-xaxis-grid-line',
};

const BxfDataVizDefaultOptions = {
    chart: {
        styledMode: true,
        spacing: [24, 24, 24, 24],
    },
    lang: {
        decimalPoint: '.',
        thousandsSep: ',',
    },
    credits: {
        enabled: false,
    },
    yAxis: {
        title: {
            text: '',
        },
        reversedStacks: false,
        visible: true,
    },
    title: {
        align: 'left',
        margin: 25,
    },
    subtitle: {
        align: 'left',
    },
    legend: {
        align: 'left',
        verticalAlign: 'bottom',
        symbolRadius: 0,
        itemMarginBottom: 8,
        enabled: true,
    },
    plotOptions: {
        series: {
            stickyTracking: false,
            label: {
                connectorAllowed: false,
            },
            marker: {
                enabled: false,
            },
            states: {
                hover: {
                    halo: {
                        size: 0,
                    },
                },
            },
        },
        scatter: {
            marker: {
                enabled: true,
            },
        },
        line: {
            marker: {
                enabled: false,
            },
        },
        pie: {
            allowPointSelect: false,
            point: {
                events: {
                    legendItemClick(event) {
                        event.preventDefault();
                    },
                },
            },
            cursor: 'pointer',
            dataLabels: {
                enabled: false,
            },
            showInLegend: true,
        },
        bar: {
            pointWidth: 25,
        },
        bullet: {
            pointPadding: 0.4,
        },
    },
    accessibility: {
        description: 'Add a Description that accurately describe the data in the chart, and what it represents', // Developers should be changing "Chart" to something more descriptive.
        keyboardNavigation: {
            enabled: true,
        },
    },
};

export { BxfDataVizConstants as B, BxfDataVizDefaultOptions as a };
